import React from 'react';


const BinaryToggleButton = ({ariaLabel, checked, onButtonClick, isDisabled = false}: {ariaLabel: string, checked: boolean, onButtonClick: ()=>void, isDisabled?: boolean}) => {
    return (
        <button
            type="button"
            className={`binary-toggle-button ${checked ? 'checked' : ''}`}
            aria-label={ariaLabel}
            aria-pressed={checked}
            disabled={isDisabled}
            onClick={onButtonClick}
            >
            <span className="binary-toggle-button__thumb" />
        </button>
    );
};

export default BinaryToggleButton